import type { NotificationItem } from '~/components/molecules/Notifications/Notifications.model';

export type NotificationItemStored = NotificationItem & {
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
  /** Runs when the subscriber dismisses the notification with its close button. */
  onClose?: () => void;
};

export  const DEFAULT_TIMEOUT = 3000;
